export default "__VITE_ASSET__a49e70c2__"